import { CALENDAR_TYPES } from '@/views/constants'
import Calendar from '@/entities/Calendar'

/*
 * if calendar can't be sorted by provider(location/practice calendars) it index should as big as it possible to push them to the end of the list
 * it needed for practices with mixed calendar
     - so provider_location calendar will be sorted by  provider sort_id on the top of the list,
       and location calendar will be pushed to the bottom of the list
       with DEFAULT_PROVIDER_SORT_INDEX using instead of 0 sort_id
 */
const DEFAULT_PROVIDER_SORT_INDEX = 100

/*
  sorting indexes information
  calculates 2 times
    1. inside Calendar entity constructor(using only original providers/locations data)
    2. as one of last steps of calendarDataProcessor with (using borrowed data also to sort firstly by borrowed providerId)
 */
export default class CalendarSortingInfo {
  constructor (calendar = new Calendar(), providerIndexes = [], locationIndexes = []) {
    const couldBeSortedByLocation = calendar.displayInfo.displayLocations.current &&
      [CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.LOCATION_TYPE].includes(calendar.type)
    const couldBeSortedByProvider = calendar.displayInfo.displayProviders.current &&
      [CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.PROVIDER_TYPE].includes(calendar.type)
    const displayLocationSortId = +(couldBeSortedByLocation ? (calendar.displayInfo.displayLocations.current?.sortId || 0) : 0)
    const displayProviderSortId = +(couldBeSortedByProvider ? (calendar.displayInfo.displayProviders.current?.sortId || DEFAULT_PROVIDER_SORT_INDEX) : DEFAULT_PROVIDER_SORT_INDEX)
    let locationPosition = couldBeSortedByLocation ? locationIndexes.indexOf(+calendar.displayInfo.displayLocations.current.id) : 0
    locationPosition = locationPosition >= 0 ? locationPosition : 0
    let providerPosition = couldBeSortedByProvider ? providerIndexes.indexOf(+calendar.displayInfo.displayProviders.current.id) : DEFAULT_PROVIDER_SORT_INDEX
    providerPosition = providerPosition >= 0 ? providerPosition : DEFAULT_PROVIDER_SORT_INDEX
    const originalProviderSortId = couldBeSortedByProvider ? calendar.originalProviders.current?.sortId : 0

    /*
    * How it works?
    * calendars sorts by provider(display provider + original provider) and then by location
    * *** provider sorting part(main) ***
    * - if providers were sorted manually - providerSortId will make the biggest impact
    * - if providers weren't sorted - providerPosition will  create "provider sorting part" for calendar sortId
    * cause providerSortId will be equal for all calendars
    * *** location sorting part(secondary) ***
    * - if locations were sorted manually - locationSortId will be used as sortIndex for calendar(after provider sorting)
    * - if locations weren't sorted - locationPosition will create "location sorting part" for calendar sortId
    * cause locationSortId will be equal for all calendars
    *
    * *** main statements ***
    * 1. provider calendar
    * 1. location calendars always shown after provider_location calendars for practices with mixed calendar types
    * */

    this.provider = `${displayProviderSortId}.${providerPosition}` * 10
    this.location = `${displayLocationSortId}.${locationPosition}` * 10
    this.calendarDebugIndex = `${displayProviderSortId}.${originalProviderSortId}.${providerPosition}.${displayLocationSortId}.${locationPosition}`
    this.calendar = +`${displayProviderSortId}${originalProviderSortId}${providerPosition}${displayLocationSortId}${locationPosition}` * 10
  }
}
